import React, { FC, useMemo } from 'react';
import { BulkSolutionModalProps } from './BulkSolutionModalProps';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  Sheets,
} from '@ingka/modal';
import Button from '@ingka/button';
import SolutionsTab from '../SolutionsTab';

const BulkSolutionModal: FC<BulkSolutionModalProps> = ({
  visible,
  closeHandler,
  saveSolutionsHandler,
  project,
}) => {
  const disabledFields = useMemo(() => {
    return project?.realEstateSISAN ? ['ALL'] : [];
  }, [project]);

  return (
    <Modal visible={visible} handleCloseBtn={closeHandler}>
      <Sheets
        alignment={'right'}
        size={'medium'}
        header={
          <ModalHeader
            titleId={'solution-title-id'}
            title="Add solutions"
            backBtnClick={closeHandler}
          />
        }
        footer={
          <ModalFooter>
            <Button text="Cancel" type="secondary" onClick={closeHandler} />
            <Button text="Save" type="primary" onClick={saveSolutionsHandler} />
          </ModalFooter>
        }
      >
        <ModalBody>
          <SolutionsTab disabledFields={disabledFields} hideInlineMessage />
        </ModalBody>
      </Sheets>
    </Modal>
  );
};

export default BulkSolutionModal;
